/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const createCoverBatch = params => {
  return axios.post(`${base}/cover_estimate_upload`, params)
}



// WEBPACK FOOTER //
// ./src/views/cover-estimate/cover-estimate.api.js